import { showToast } from "@libs/useful"
import { __ } from "@libs/utilities"
import actions from "@/modules/pe-basic-module/data/actions"
import { UPDATE_SINGLE_TYPE } from "@/modules/pe-basic-module/data/actionTypes"
import { IUser, useMainStore } from "../zustand"
import { Intent } from "@blueprintjs/core"

export default function setBoundaryError(error: Error) {
    const user :IUser = useMainStore.getState().user
    const landId = useMainStore.getState().landId
    const userAgent = window.navigator.userAgent
    const language = window.navigator.language
    const platform = window.navigator.platform 
    const message = error.message 
    showToast({
        message,
        timeout: 10000,
        intent: Intent.DANGER,
        icon: "error",
    })
    if( process.env.NODE_ENV === "development" ) {
        return
    }
    actions(
        UPDATE_SINGLE_TYPE,
        {
            land_id: landId,
            data_type: "Boundary",
            input: {
                user_id: user.id,
                user: JSON.stringify(user),
                user_agent: userAgent,
                language,
                platform,
                stack: JSON.stringify(error.stack),
                message: error.message
            }
        }
    )
    .then(() => {
        const message = __("A report of the precedent has been sent to the developers. The problem will be fixed shortly. We apologize for the temporary inconvenience.")
        showToast({
            message,
            timeout: 10000,
            intent: Intent.SUCCESS,
            icon: "cloud-upload"
        })
    })
}